export default "__VITE_ASSET__CqFTwE5p__"